import { Box, BoxProps, Slide, styled } from "@mui/material";

const Wrapper = styled(Box)(({ theme }) => ({
  zIndex: 10000,
  position: "fixed",
  width: "366px",
  bottom: theme.spacing(6),
  right: theme.spacing(6),
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1.5, 2),
  border: `2px solid ${theme.palette.border.secondary}`,
  boxShadow: theme.shadows[1],
  borderRadius: `${theme.shape.borderRadius}px`,
}));

export interface StatusPopupProps extends BoxProps {
  in: boolean;
}

export const StatusPopup = ({
  in: isOpen,
  children,
  ...boxProps
}: StatusPopupProps) => (
  <Slide in={isOpen} direction="left">
    <Wrapper {...boxProps}>{children}</Wrapper>
  </Slide>
);
